/* takes two non-overlapping sets of readings, period A and period B
    reports on the differences between the two sets, either in aggregate
    or by device. */
import { siteAccessCode } from '../../database/apiv2SiteAccessor'
import SecondServer from '../../database/SecondServer'
import {readings} from '../HistoricalData'
import {dateSort} from '../helperfunctions'

export function TrendData (props, ti, radioId = undefined) {
  const ss = new SecondServer(props)
  const siteId = siteAccessCode(props.getActiveSite())
  // to do, fetch site data if radio id undefined
  const pr1 = readings (ss, siteId, radioId, ti.later.s, ti.later.e)
  const pr2 = readings(ss, siteId, radioId, ti.prev.s, ti.prev.e)
  return Promise.all([pr1, pr2])
}
export function Trend (arrData, ti) {
  return reduce (arrData)
}
export function reduce (arrData) {
  const byDate = arrData.map (arrItem => dateSort(arrItem, 'readTime'))
  const diff = byDate.map(period => period[0]?.readings.map(
    read => difference(read, period)
  ))
  return diff
}
function difference (reading, period) {
  const start = farEnd(reading.sensorType, period)
  return {sensorType: reading.sensorType, delta: reading.value - start.value}
}
function farEnd(sensorType, arrData) {
  return arrData[arrData.length-1].readings.find (i => i.sensorType === sensorType)
}
